import React from "react";
import { TextField, Box } from "@mui/material";
import { getFieldLabel } from "../../constants/Helpers";
import HelpText from "../HelpText/HelpText";

function NumBuoyLines({ numBuoyLines, handleChange }) {
  return (
    <Box m={0} width="100%" align="center">
      <h2 className="sectionTitle center">
        {getFieldLabel("effort", "numBuoyLines")}
      </h2>
      <TextField
        name="numBuoyLines"
        variant="standard"
        inputProps={{
          min: 1,
          style: { textAlign: "center" },
        }}
        size="small"
        type="number"
        value={numBuoyLines}
        onChange={handleChange}
      />
      <HelpText
        helpText={getFieldLabel("effort", "numBuoyLines", "helptext")}
      />
    </Box>
  );
}

export default NumBuoyLines;
